import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
	saveThemePreferenceSchema,
	type SaveThemePreference,
} from '../../../theme/types/themePreference.types';
import { toApiError } from '../utils';
import { themePreferenceQueryKey } from './useGetThemePreference';
import api from '../../http';

export const usePostThemePreference = (userId: string | null) => {
	const queryClient = useQueryClient();
	const queryKey = themePreferenceQueryKey(userId);

	return useMutation({
		onMutate: () => queryClient.cancelQueries({ queryKey }),
		mutationFn: async (preference: SaveThemePreference): Promise<SaveThemePreference> => {
			if (!userId) throw new Error('Entre na sua conta para salvar o tema.');
			try {
				const { data } = await api.post<unknown>('/user/saveThemePreference', preference);
				return saveThemePreferenceSchema.parse(data);
			} catch (error) {
				throw toApiError(error, 'Erro ao salvar preferência de tema');
			}
		},
		onSuccess: (preference) => {
			queryClient.setQueryData<SaveThemePreference>(queryKey, preference);
		},
	});
};
